import features from '~/features';
import { Features } from './types/Features';
import defaultsDeep from './utils/defaultsDeepES';

const defaults: Features = {
  niDemo: false,
  i18n: {
    userLanguages: ['en-US'],
    fallbackLng: 'en-US',
  },
  kyc: {
    kycNotCompletedIf: (business) =>
      business?.kycLevel === 'basic' ||
      business?.kycLevel === 'bronze' ||
      business?.kycLevel === 'not_verified',
    kycStatusWait: ['PENDING'],
    applyForKycLevel: {
      startKycProcess: 'verified',
    },
    extraFields: {
      legalType: true,
      legalName: true,
      tradeName: true,
      industry: true,
      merchantCategoryCode: true,
    },
  },
  showCaptcha: false,
  successPasswordResetOptions: {
    enabled: false,
    options: [],
  },
  payrolls: {
    enabled: false,
  },
  ownAccountTransfer: {
    enabled: false,
  },
  balanceTypesOnDashboard: [
    'CURRENT_AVAILABLE',
    'CURRENT_PENDING',
    'CURRENT_POSTED',
    'CURRENT_FLOAT',
  ],
};

export default defaultsDeep(features, defaults) as typeof defaults;
